import classNames from 'classnames';

import {gradeConvertor} from '../subCardSwitcher/uitilities';
import BadgeSwitcher from '../badgeSwicher';
import {textLengthLimiter} from '../helper';

interface INewAdMainCardProps {
  createdDate: string;
  image: string;
  title: string;
  price: string;
  state: string;
  city: string;
  degree: string | null;
  wrapperClassName?: string;
  isExpired: boolean;
  isSold: boolean;
  homeCards?: boolean;
  negotiated_price: boolean | undefined;
  is_distinguished : boolean | undefined
}
const SimpleCard = ({
  createdDate,
  image,
  title,
  price,
  state,
  city,
  degree,
  wrapperClassName,
  isExpired,
  isSold,
  homeCards,
  negotiated_price,
  is_distinguished
}: INewAdMainCardProps) => {
  return (
    <>
      <div
        className={classNames(
          'flex  justify-between rounded-lg mx-2 h-[144px] px-2   w-72 ',

          homeCards
            ? 'h-36 shadow-md  !py-2'
            : `${wrapperClassName} h-40 shadow-card`,
            is_distinguished  ? " bg-destinguished-bg border border-solid border-destinguished " : "bg-white"
        )}
      >
        <div className="relative flex items-center !w-[128px] h-full">
          <div
            className={classNames(
              ' absolute  right-1 text-xs text-created-day   px-2 rounded-3xl',
              {'top-4': !homeCards},
              {'top-[10px]': homeCards},
            )}
          >
            <BadgeSwitcher
              createdDate={createdDate}
              isExpired={isExpired}
              isSold={isSold}
            />
          </div>
          <img
            className={classNames(
              'object-cover  rounded-lg flex-none w-[128px] h-[128px]',
              homeCards && ' !w-[110px]',
            )}
            src={image}
            alt={title}
          />
        </div>
        <div className=" flex flex-col grow pl-2 justify-between gap-4 h-full w-[55%]">
          <div className="flex flex-col grow px-2 py-1 gap-2 h-full justify-between">
            <div className="flex w-full mt-2 justify-between">
              <p
                className={classNames(
                  ' text-black  text-sm font-extrabold text-start w-[80%] break-words !max-w-[154px]',
                  {'!max-w-[114px]': homeCards},
                )}
              >
                {textLengthLimiter(title, 20)}
              </p>
              {degree && (
                <span className="w-[23px]">
                  {gradeConvertor[Number(degree)]}
                </span>
              )}
            </div>
            <div className="flex flex-col w-full gap-2 mb-2">
              {negotiated_price ? (
                <p className="mb-2 font-extrabold	text-[12px]  text-gray-6 grow text-start">
                  قیمت توافقی
                </p>
              ) : (
                <>
                  {price && (
                    <p className=" text-xs text-gray-6  text-start">
                      {Number(price).toLocaleString()} تومان
                    </p>
                  )}
                </>
              )}
              <div className="flex items-end h-[45%] justify-between">
                <div
                  className={classNames(
                    'flex',
                    homeCards && degree && 'inline-block w-[80px]',
                  )}
                >
                  {!state ? (
                    <p></p>
                  ) : city ? (
                    <>
                      <span className="icon-location text-primary text-xs pl-1" />
                      <p
                        className={classNames(
                          ' font-normal text-xs text-gray-6',
                          degree && 'truncate block',
                        )}
                      >
                        {state}،{city}
                      </p>
                    </>
                  ) : (
                    <>
                      <span className="icon-location  text-primary text-xs pl-1" />
                      <p className=" font-normal text-xs text-gray-6">
                        {state}
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SimpleCard;
